import { fromJS } from 'immutable';
import { structure } from '@debatdirect/core/core';
import { InitError, ResizeHandler, SplashScreenHandler, ConnectionHandler, urlParams } from '@debatdirect/core/bootstrap';
import { container } from '@debatdirect/common/src/modules/container';
import type PlatformService from '@debatdirect/ui-react/src/services/PlatformService';

import config from './config';

export const bootstrapLegacy = async () => {
  // Save the initialUrl
  const initialUrl = window.location.href;
  const initialUrlParams = new URLSearchParams(window.location.search);

  // global fix (still needed?)
  window.global = window;

  // Update structure with config and url parameters.
  structure
    .cursor()
    .setIn(['config'], fromJS(config))
    .setIn(['ui', 'settings', 'baseUrl'], config.baseUrl)
    .setIn(['ui', 'settings', 'hd'], initialUrlParams.get('hd') === '1')
    .setIn(['ui', 'settings', 'api', 'baseUrl'], config.api.baseUrl)
    .setIn(['ui', 'settings', 'api', 'cdnBaseUrl'], config.api.cdnBaseUrl)
    .setIn(['ui', 'width'], document.body.offsetWidth)
    .setIn(['ui', 'seekEvent'], urlParams.getInitialEvent())
    .setIn(['ui', 'entryParams'], urlParams.getUrlParams().raw)
    .setIn(['auth', 'initialUrl'], initialUrl);

  // Show splash screen.
  SplashScreenHandler.show(config.staticUrl);

  // Initialize connection handler.
  ConnectionHandler.init(structure);

  // Initialize resize handler.
  ResizeHandler.init(structure);

  // Add touch-device class to HTML element if appropriate.
  if (container.get<PlatformService>('platform').isTouchDevice()) {
    document.documentElement.classList.add('touch-device');
  }

  initView();
};

/**
 * Initialize view.
 */
let initView = () => {
  // Hide error.
  InitError.hide();

  // Fade out splash screen.
  SplashScreenHandler.hide();

  // Override init view to prevent multiple calls.
  initView = function () {};
};
